import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {SpinReelEvent} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelEvent";
import {FruitsGameConfig} from "../../FruitsGameConfig";
import {FruitsGameModuleConfig} from "../../FruitsGameModuleConfig";
import {FruitsSoundConfig} from "../../FruitsSoundConfig";
import {FruitsGameMode} from "../../gamemode/FruitsGameMode";
import {FruitsReels} from "../../reel/reelarea/FruitsReels";
import {FruitsReelSymbol} from "../../reelsymbol/FruitsReelSymbol";
import {FruitsParsedGameData} from "../../server/data/FruitsParsedGameData";

/**
 * Created by h3 on 2018-09-07.
 */

export class FruitsScatterReelStopPresentation extends ReelStopPresentationController {
    private _mode:string;
    private _isBonusTriggeredThisSpin:boolean;
    private _scatterCount:number = 0;
    private _parsedSymbolOverlayPositions:boolean[][];
    private _overlayStickySymbolsBeforeSpin:boolean[];
    private _parsedBonusOverlayPositions:boolean[];
    private _secondScatter:number = -1;
    private _orientation:Orientation;

    constructor(index:number) {
        super(index, "FruitsScatterReelStopPresentation");

        EventHandler.addEventListener(this, FruitsReels.SET_ORIENTATION, (event:GameEvent) => this.onOrientationChange(event.params[0]));
    }

    protected parseFeatureGameData(data:FruitsParsedGameData):void {
        this._mode = data.mode;
        this._isBonusTriggeredThisSpin = data.isBonusTriggeredThisSpin;
        this._parsedSymbolOverlayPositions = FruitsScatterReelStopPresentation.parseSymbolOverlayPositions(data.symbolOverlayPositions);
        this._overlayStickySymbolsBeforeSpin = data.overlayStickySymbolsBeforeSpin;
        this._parsedBonusOverlayPositions = FruitsScatterReelStopPresentation.parseBonusOverlayPositions(data.bonusOverlayPositionsAfter, data.bonusOverlayPositionsBefore);
        this._secondScatter = -1;
    }

    private static parseBonusOverlayPositions(bonusOverlayPositionsAfter:boolean[][], bonusOverlayPositionsBefore:boolean[][]):boolean[] {
        const parsedBonusOverlayPositions = [];

        for(let i:number = 0; i < bonusOverlayPositionsAfter.length; i++) {
            for(let j:number = 0; j < bonusOverlayPositionsAfter[i].length; j++) {
                parsedBonusOverlayPositions.push(bonusOverlayPositionsAfter[i][j] !== bonusOverlayPositionsBefore[i][j]);
            }
        }

        return parsedBonusOverlayPositions;

    }


    private static parseSymbolOverlayPositions(symbolOverlayPositions:boolean[][]):boolean[][] {
        let parsedSymbolOverlayPositions = [];
        for(let i = 0; i < symbolOverlayPositions.length; i++) {
            for(let j = 0; j < symbolOverlayPositions[i].length; j++) {
                if(i === 0 && j === 0 || i === 1 && j === 0) {
                    continue;
                }
                parsedSymbolOverlayPositions.push([symbolOverlayPositions[i][j]]);
            }
        }
        return parsedSymbolOverlayPositions;
    }

    private changeSpeed(data:IReelStoppedData) {

        if(data.reelId === 11 && this._mode === FruitsGameMode.BONUS_GAME) {
            EventHandler.dispatchEvent(new GameEvent(SpinReelEvent.REEL_SET_CURRENT_REEL_SET, {reelSetName : "BONUS_GAME_REELSET_FAST"}));
            for(let i:number = 12; i < 16; i++) {
                EventHandler.dispatchEvent(new GameEvent(SpinReelEvent.REEL_SET_SPIN_SPEED, {
                    reelId : i,
                    spinSpeed : 0.02,
                    fadeInTime : 0
                }));
            }
        }
    }

    public onReelBounce(data:IReelStoppedData):void {
        this.handleExceptions();
        this.changeSpeed(data);

        let lastReel = this._orientation === Orientation.PORTRAIT ? 13 : 15;

        const symbol:FruitsReelSymbol = <FruitsReelSymbol>Reels.getSymbol(data.reelId, 0)!;

        if(symbol && symbol.symName.substr(0, 1) === "S") {
            this._scatterCount += 1;
            if(this._scatterCount === 2 && this._secondScatter === -1) {
                if(this._gameData!.mode !== FruitsGameMode.BONUS_GAME) {
                    SlotGame.sound.playEffect(FruitsSoundConfig.ANTICIPATION);
                }
                this._secondScatter = data.reelId;
            }
            if(this._scatterCount === 3) {
                if(this._gameData!.mode !== FruitsGameMode.BONUS_GAME) {
                    SlotGame.sound.playEffect(FruitsSoundConfig.ANTICIPATION);
                }
            }
            symbol.changeState({
                state : FruitsGameConfig.instance.SYMBOL_STATES.win,
                fadeInDuration : 0,
                replay : false
            });
            this.playScatterAttentionSound(data.reelId);


        }
        if(data.reelId === lastReel) {
            SlotGame.sound.stopEffect(FruitsSoundConfig.ANTICIPATION);
            if(this._scatterCount === 2 && this._gameData!.mode !== FruitsGameMode.BONUS_GAME)
                SlotGame.sound.playEffect(FruitsSoundConfig.ANTICIPATION_FAIL);
        }
        this.dispatchCompleteEvent(data.reelId);
    }

    private playScatterAttentionSound(reelId:number):void {
        // skip scatter attention sound if scatter is below an overlay symbol or overlay sticky symbol
        if(this._parsedSymbolOverlayPositions[reelId][0] || this._overlayStickySymbolsBeforeSpin[reelId]) {

            return;
        }

        if(this._mode === FruitsGameMode.BONUS_GAME) {
            if(this._parsedBonusOverlayPositions[reelId]) {
                SlotGame.sound.playEffect(FruitsSoundConfig.SCATTER_ATTENTION);
            }
            return;
        }

        if(this._scatterCount === 3) {
            SlotGame.sound.playEffect(FruitsSoundConfig.SCATTER_WIN);
        }

        if(this._scatterCount !== 3) {
            SlotGame.sound.playEffect(FruitsSoundConfig.SCATTER_ATTENTION);
        }
    }

    public playReelBouncingSound(data:IReelStoppedData):boolean {
        return false;
    }

    public playReelStopSound(data:IReelStoppedData):boolean {
        return false;
    }

    public onReelSpinStopped(data:IReelStoppedData):void {
        if((<FruitsParsedGameData>this._gameData!).isStickyRespinTriggeredThisSpin && (<FruitsParsedGameData>this._gameData!).isBonusTriggeredThisSpin && data.reelId === 15) {
            let rInd:number = 0, sInd:number = 0;
            (<FruitsParsedGameData>this._gameData!).bonusOverlayPositionsAfter.forEach((rl) => {
                sInd = 0;
                rl.forEach((value) => {
                    if(value) {
                        FruitsGameModuleConfig.bonusOverlayView.activateScatterFrame(4 + rInd * 3 + sInd);
                    }
                    sInd++;
                });
                rInd++;
            });
        }
    }

    protected resetFeature():void {
        this._scatterCount = 0;
        if(super.resetFeature) {
            super.resetFeature();
        }
    }

    private handleExceptions():void {
        if(this._mode === FruitsGameMode.STICKY_RESPIN) {
            for(let i:number = 0; i < 4; i++) {
                this.dispatchCompleteEvent(i);
            }
        }
    }

    private onOrientationChange(orientation:Orientation) {
        this._orientation = orientation;
    }
}